<template>
  <div>
    <FieldsetModel
      :ui="uiBaseFieldset"
      :name="FIELDSET_NAMES.email"
      :ui-title="title"
      :ui-subtitle="subtitle"
    >
      <UiWrapper
        :name="FIELD_NAMES.email"
        :label="label"
        :validations="validations"
      >
        <InputText />
      </UiWrapper>
    </FieldsetModel>
  </div>
</template>

<script>
import { InputText } from '@dunia/ui';
import * as conditions from '@/forms/conditions';
import { EMAIL_VALIDATION_PATTERN } from '@/forms/constants/onboarding-logic';
import sharedComponentMixin from '@/forms/components/shared/shared-component-mixin';

export default {
  name: 'FieldsetEmail',

  props: {
    title: {
      type: String,
      default: 'Your email address is',
    },
    subtitle: {
      type: String,
      default: 'We will use this email to send you updates on your application. We will first send you a link on this email so you can verify it.',
    },
    label: {
      type: String,
      default: 'Email address',
    },
    validations: {
      type: Array,
      default: () => ([
        {
          errorMessage: 'Please type a valid email',
          condition: conditions.patternCondition(EMAIL_VALIDATION_PATTERN),
          name: 'check-is-email',
        },
      ]),
    },
  },

  mixins: [sharedComponentMixin],

  data: () => ({
    EMAIL_VALIDATION_PATTERN,
  }),

  components: {
    InputText,
  },
};
</script>

<style>

</style>
